import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRecolectores = async () => {
    try {
      const userInfo = fetchUser();
      if (!userInfo || !userInfo.empresa) {
        throw new Error('Información usuario no disponible.');
      }
      const {data}  = await Axios.get(
        `/recolectores?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getRecolectoresEstado = async (estado) => {
    try {
      const userInfo = fetchUser();
      if (!userInfo || !userInfo.empresa) {
        throw new Error('Información usuario no disponible.');
      }
      const {data}  = await Axios.get(
        `/recolectores/estado?empresa=${userInfo.empresa}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRecolectoresRut = async (rut) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/recolectores/rut?empresa=${userInfo.empresa}&rut=${rut}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRecolectoresEmail = async (email) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/recolectores/email?empresa=${userInfo.empresa}&email=${email}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRecolectoresId = async (idRecolector) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/recolectores/id?empresa=${userInfo.empresa}&idRecolector=${idRecolector}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRecolector = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/recolectores', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRecolector = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/recolectores/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRecolector = (Id) => Axios.delete(`/recolectores/${Id}`);